// @ts-check
/**
 * @file taskSelectors.js
 * @location src/utils/taskSelectors.js
 * @role task 배열 공용 필터 셀렉터. (구 latestReport 는 검수 폐기 razor ㉓ 로 제거)
 */
import { isClosed } from '../data/labels.js';
import { formatDate } from './dateUtils.js';

/**
 * 「오늘 기준」 업무 가시성 — 미종결은 항상, 종결(완료/중지)은 당일분만 표에 남김.
 * 당일 지난 종결 업무는 이력로 빠진다(데이터는 S.tasks 에 유지, 표시만 제외).
 * @param {import('../data/types.js').Task[]} tasks
 * @param {string} today  YYYY-MM-DD
 * @returns {import('../data/types.js').Task[]}
 */
export const activeOrClosedToday = (tasks, today) =>
  tasks.filter(t => {
    if (!isClosed(t.status)) return true;
    const iso = t.completedAt || t.cancelledAt;
    if (!iso) return false;
    const d = new Date(iso);
    // 로컬 날짜로 비교 — completedAt 은 UTC(ISO)라 slice 하면 타임존 어긋남(getTodayStr=로컬)
    return Number.isFinite(d.getTime()) && formatDate(d) === today;
  });

/**
 * 미래 예정 판정 — 지정일(ondate)이고 due 가 오늘보다 뒤이며 미종결.
 *   완료 확인 다이얼로그 분기에 사용(조기기 완료는 이례적이라 확인). done/cancelled 은 isClosed 로 제외.
 * @param {import('../data/types.js').Task} task
 * @param {string} today  YYYY-MM-DD
 * @returns {boolean}
 */
export const isFutureYotei = (task, today) =>
  task.dateKind === 'ondate' && !!task.due && task.due > today && !isClosed(task.status);

/**
 * 담당자별 부하 Map<aee, 미완료건수>.
 *   dateStr 없음 → 전체 미완료 / dateStr 있음 → 그 날짜의 지정일(ondate) 미완료만.
 * @param {import('../data/types.js').Task[]} tasks
 * @param {string|null} [dateStr]  YYYY-MM-DD (내일 보드 부하용)
 * @returns {Map<string, number>}
 */
export const buildLoadMap = (tasks, dateStr = null) => {
  const m = new Map();
  for (const t of tasks) {
    if (!t.aee || isClosed(t.status)) continue;
    if (dateStr && (t.dateKind !== 'ondate' || t.due !== dateStr)) continue;
    m.set(t.aee, (m.get(t.aee) ?? 0) + 1);
  }
  return m;
};
